import { Component } from '@angular/core';
import { HlAreaComponent } from './hl-area.component';
import { Baumart, trackByIndex } from 'src/app/data-model';

/**
 * Probestaemme-Tabelle (Punktart 1-4: Grube).
 * Bearbeitet `extendedHeader.baumarten` als Baumart[]. Alt-Strings bleiben
 * erhalten und werden read-only mit Migration-Hinweis angezeigt.
 */
@Component({
    standalone: false,
    selector: 'bp-baumarten',
    templateUrl: './baumarten.component.html',
    styleUrls: ['./hl-area.component.css']
})
export class BaumartenComponent extends HlAreaComponent {
    trackByIndex = trackByIndex;

    /** Liefert die Baumart-Liste — leeres Array, falls Feld leer/String. */
    baumartenList(): Baumart[] {
        const ba = this.data.extendedHeader?.baumarten;
        if (Array.isArray(ba)) return ba;
        return [];
    }

    /** True wenn baumarten ein nicht-leerer Legacy-String ist. */
    hasLegacyString(): boolean {
        const ba = this.data.extendedHeader?.baumarten;
        return typeof ba === 'string' && ba.trim().length > 0;
    }

    legacyString(): string {
        const ba = this.data.extendedHeader?.baumarten;
        return typeof ba === 'string' ? ba : '';
    }

    /** Konvertiert Legacy-String zu leerer Tabelle (User uebernimmt Werte manuell). */
    migrateLegacyToTable() {
        const legacy = this.legacyString();
        if (!legacy) return;
        // Wir loeschen den String nicht — er bleibt zusaetzlich als Bemerkung sichtbar,
        // bis der User Zeilen befuellt und der String haendisch geleert wird.
        // Stattdessen initialisieren wir das Array.
        if (!Array.isArray(this.data.extendedHeader.baumarten)) {
            this.data.extendedHeader.baumarten = [];
        }
        this.onAddBaumart();
    }

    onAddBaumart() {
        if (!Array.isArray(this.data.extendedHeader.baumarten)) {
            this.data.extendedHeader.baumarten = [];
        }
        const ba: Baumart = {
            art: '',
            alter: 0,
            hoehe: { first: 0, second: 0 },
            durchmesser: { first: 0, second: 0 },
            Bonitaet: 0,
            qualitaet: ''
        };
        (this.data.extendedHeader.baumarten as Baumart[]).push(ba);
        this.vs.dirty.next(true);
    }

    onRemoveBaumart(i: number) {
        const list = this.baumartenList();
        if (i < 0 || i >= list.length) return;
        for (const key of ['BaumartArt', 'BaumartAlter', 'BaumartHoeheVon', 'BaumartHoeheBis',
                'BaumartDurchmesserVon', 'BaumartDurchmesserBis', 'BaumartBonitaet', 'BaumartQualitaet']) {
            this.vs.clearCommentsNoSave(`${key}[${i}]`);
        }
        list.splice(i, 1);
        this.vs.dirty.next(true);
    }

    /** Loescht den Legacy-String, sobald der User mit der Tabelle weiter ist. */
    clearLegacyString() {
        if (typeof this.data.extendedHeader.baumarten === 'string') {
            this.data.extendedHeader.baumarten = this.baumartenList();
        }
    }
}
